// TODO ZL-856: replace this custom infrastructure with Firebase Remote Config
import { createContext, useContext } from 'react'

const FeatureFlagUserIdContext = createContext<string | null>(null)

export const FeatureFlagUserIdProvider = FeatureFlagUserIdContext.Provider

export const useFeatureFlagUserId = () => useContext(FeatureFlagUserIdContext)
